import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { renderHTML } from '../../../helpers/render-html';
import { useLanguage } from '../../../helpers/language-context';
import { supabase } from '../../../supabaseClient';

import Header from '../../../components/header';
import StatisticsEffectBg from '../../../components/statistic-effect-bg';
import Milestone from './milestone';

const ArrowRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

const ServiceDetail = () => {
  const navigate = useNavigate();
  const { translations, language } = useLanguage();
  const { serviceId } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchService = async () => {
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .eq('id', serviceId)
        .single();

      if (error || !data) {
        navigate('/services');
        window.scrollTo(0, 0);
      } else {
        setService(data);
      }
      setLoading(false);
    };

    fetchService();
  }, [serviceId, navigate]);

  if (loading || !service) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  const title = language === 'en' ? service['title-en'] : service['title-my'];
  const detailTitle = language === 'en' ? service['detail-title-en'] : service['detail-title-my'];
  const description = language === 'en' ? service['detail-desc-en'] : service['detail-desc-my'];
  const bgImage = service['image'];
  const milestones = service['milestones'];

  return (
    <div className="services-container">
      <Header title={title} bgImg={bgImage} back={true} backLink='/services' backText={translations.navbar.ourServices} />
      <section className="bg-white">
        <div className="flex flex-col space-y-4 text-center justify-center items-center mx-auto">
          <div className="md:max-w-[60%]">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#28357B] mb-4 md:mb-8">{detailTitle}</h2>
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(description)} />
          </div>
        </div>
      </section>

      {/* images */}
      <div className="w-full h-[35vh] md:h-[45vh] flex">
        <img
          src="/assets/images/section-img/section_intro_ourTeam.jpg"
          alt={`${serviceId} 1`}
          className="w-1/2 h-full object-cover"
        />
        <img
          src="/assets/images/section-img/section_serviceDetail2.jpg"
          alt={`${serviceId} 2`}
          className="w-1/2 h-full object-cover"
        />
      </div>

      {/* milestone */}
      <StatisticsEffectBg className="text-white" waveSize="small">
        <Milestone milestones={milestones} />
      </StatisticsEffectBg>

      {/* image */}
      <div className="bg-white w-full">
        <div className="h-screen">
          <img src="/assets/images/section-img/section_serviceDetailLg.jpg" alt="Board" className="object-cover h-screen w-full" />
        </div>
      </div>

      {/* contact us */}
      <section className="bg-white">
        <div className="flex flex-col space-y-4 text-center justify-center items-center mx-auto">
          <div className="md:max-w-[60%]">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#28357B] mb-4 md:mb-8">{translations.services.weAreReadyToHelpYou}</h2>
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <button className=" flex items-center justify-center gap-2 bg-[#28357B] text-white px-6 py-3 rounded-[3rem] text-sm font-medium">
              {translations.button.contactUs}
              <ArrowRight />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
